import { gsap } from 'gsap'
import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.mask = this.el.querySelector('.c-contact_mask')
    // this.header =  this.el.querySelector('.o-section_header');
  }

  init() {
  }

  enter() {
    const tl = gsap.timeline()

    tl.fromTo(
      this.mask,
      { scale: 4 },
      {
        scale: 1,
        duration: 1,
        ease: 'expo.out'
      }
    )
    // tl.fromTo(
    //     this.header,
    //     { opacity: 0 },
    //     { opacity: 1, duration: 0.6, ease: 'none' },
    //     '-=0.4'
    // )
  }
}
